module.exports = __webpack_public_path__ + "img/head-adapter.be8fe2f2.png";